import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppConstants } from "../constants/constants";
import { APP_CONFIG } from "../lib/angular/injection-tokens";
import { IAppConfig } from "../lib/config/app-config";
import { Administrator, AdministratorList, EditAdministrator, UpdateAdministratorListDTO } from "../_models/Administrator";
import { UserEmail, Userprofile } from "../_models/Userprofile";

@Injectable({
  providedIn: "root",
})
export class AdministratorService {
  private baseUrl: string = this.config.protectedResourceEndpoint;
  private static readonly path: string = "Administrator/";
  private static readonly DISPLAY_ADMINISTRATOR_LIST =
    "displayadministratorlist";
  private static readonly ADMINISTRATOR_LIST_LENGTH = "administratorlistlength";
  private static readonly UPDATE_ADMINISTRATOR_LIST = "updateadministratorlist";
  private static readonly RESET_ADMINISTRATOR_LIST = "resetadministratorlist";

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {}

  public addAdministrator$(administrator: Administrator): Observable<Object> {
    return this.http.post(
      this.baseUrl + AppConstants.ADMINISTRATOR,
      administrator
    );
  }

  public getAllAdminByOrgCentre$(
    orgId: number,
    centreId: number
  ): Observable<Userprofile[]> {
    let queryParams = "";
    if (orgId) {
      queryParams = "?orgId=" + orgId;
      queryParams += centreId ? "&centreId=" + centreId : "";
    }
    return this.http.get<Userprofile[]>(
      this.baseUrl +
        AppConstants.ADMINISTRATOR +
        "/getbyorgcentre" +
        queryParams
    );
  }

  public updateAdministrator$(
    adminId: number,
    admin: EditAdministrator
  ): Observable<Object> {
    return this.http.put(
      `${this.baseUrl}${AppConstants.ADMINISTRATOR}${AppConstants.UPDATE_ADMIN}${AppConstants.SLASH}${adminId}`,
      admin
    );
  }

  public addUserProfile$(userprofile: Userprofile) {
    return this.http.post(
      this.baseUrl + AppConstants.USER_PROFILE,
      userprofile
    );
  }

  public deleteAdministrator$(adminId: number[]): Observable<Object> {
    return this.http.request(
      AppConstants.DELETE,
      this.baseUrl + AppConstants.ADMINISTRATOR,
      { body: adminId }
    );
  }

  public getAdministratorTableRecords$(
    pageNumber: number,
    isInitialLoad: boolean
  ): Observable<AdministratorList[]> {
    let params = new HttpParams().set("pageNumber", String(+pageNumber + 1));
    if (isInitialLoad)
      params = params.set("isInitialLoad", String(isInitialLoad));

    return this.http.get<AdministratorList[]>(
      this.baseUrl +
        AdministratorService.path +
        AdministratorService.DISPLAY_ADMINISTRATOR_LIST,
      { params }
    );
  }

  public getAdministratorListLength$(): Observable<number> {
    return this.http.get<number>(
      this.baseUrl +
        AdministratorService.path +
        AdministratorService.ADMINISTRATOR_LIST_LENGTH
    );
  }

  public updateAdministratorTableRecords$(
    tableParameter: UpdateAdministratorListDTO
  ): Observable<boolean> {
    return this.http.put<boolean>(
      this.baseUrl +
        AdministratorService.path +
        AdministratorService.UPDATE_ADMINISTRATOR_LIST,
      tableParameter
    );
  }

  public resetAdministratorTable$(): Observable<boolean> {
    return this.http.get<boolean>(
      this.baseUrl +
        AdministratorService.path +
        AdministratorService.RESET_ADMINISTRATOR_LIST
    );
  }
}
